module.exports = "/lucky-balls/img/drum/drum_loop_041.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_041.png
// module id = 1056
// module chunks = 0